/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Losstempdelta2Inputs */



/**
* | output |
* | --- |
* | "Primary network loss" |
*
* @param {Br_History_Key_Losstempdelta2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_losstempdelta2 = /** @type {((inputs?: Br_History_Key_Losstempdelta2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Losstempdelta2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Primary network loss")
	return /** @type {LocalizedString} */ ("Perte du réseau primaire")
});
export { br_history_key_losstempdelta2 as "br_history_key_lossTempDelta" }